import { useState, useEffect } from 'react';
import * as Sentry from '@sentry/browser';
import { dtos } from '@shd/jslib/models';
import { useFacebookAuthResponse, useFacebookScopes } from '@helpers/facebook';
import axios from '@helpers/axios';

export const useFacebookConnection = (teamId: string) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [publishFB, setPublishFB] = useState<dtos.PublishFb | null>(null);
  const [showIntroModal, setShowIntroModal] = useState(false);
  const [showHowToSetUpModal, setShowHowToSetUpModal] = useState(false);
  const [showLinkingModal, setShowLinkingModal] = useState(false);
  const [stepDestinationTitle, setStepDestinationTitle] = useState(
    'Where do you want to stream to?'
  );
  const [destinationGoBack, setDestinationGoBack] = useState<() => void>();
  const fbScopes = useFacebookScopes();
  const fbAuthResponse = useFacebookAuthResponse();

  useEffect(() => {
    axios
      .get<dtos.PublishFb>('/api/facebook_auth', { params: { teamId } })
      .then((res) => {
        setPublishFB(res.data || null);
        setLoading(false);
      })
      .catch((e) => {
        Sentry.captureException(e);
        setError('Failed to fetch Facebook connection');
      });
  }, [teamId]);

  const onLinkFacebookClick = () => setShowIntroModal(true);

  const onClose = () => {
    setShowIntroModal(false);
    setShowLinkingModal(false);
    setShowHowToSetUpModal(false);
  };

  const responseFacebook = async (res: { status: string }) => {
    if (res.status === 'unknown') {
      return;
    }
    setShowLinkingModal(true);
  };

  return {
    loading,
    error,
    publishFB,
    setPublishFB,
    fbScopes,
    fbAuthResponse,
    showIntroModal,
    showHowToSetUpModal,
    showLinkingModal,
    stepDestinationTitle,
    destinationGoBack,
    setShowIntroModal,
    setShowHowToSetUpModal,
    setShowLinkingModal,
    setStepDestinationTitle,
    setDestinationGoBack,
    onLinkFacebookClick,
    onClose,
    responseFacebook,
  };
};
